const COOKIE_KEYS = {
  PRODUCT_ID_KEY: 'pid',
  CART_ID_KEY: 'crtId',
  NEW_SUBSCRIPTION_KEY: 'nsid',
  ORDER_CONFIRMED_ID: 'oid',
};

export default COOKIE_KEYS;
